import { domElementWithin } from '@utils'

export default {
    props: ["do"],
    mounted () {
        const listener = e => {
            if (domElementWithin(e.target, this.$el)) return
            this.do()
        }

        // Ensures the initial click to open the modal doesn't trigger the listener.
        setTimeout(() => {
            document.addEventListener("mouseup", listener)
        }, 0)

        // Removes the listener before destroying the component.
        this.$once("hook:beforeDestroy", () => {
            document.removeEventListener("mouseup", listener)
        })
    },
    render () {
        return this.$slots.default[0]
    }
}
